export const INVOICE_SIGNATURE_LABELS = [
  'Prepared By',
  'Checked By',
  'Approved By',
];
